export default __webpack_public_path__ + "Raleway-Regular.ttf?c15b0bf7b86f34335251a87ce0a2276a";